import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth, authSelectors, AuthStrategy, DEFAULT_SCOPE, MSALService } from '@content-platform/web-angular-shared-util-auth';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, mergeMap, switchMap } from 'rxjs/operators';
import { endpointNeedsAdalToken, getAdalEndpoint } from '../helpers/endpoint-helper';

/**
 * Interceptor for the permission API requests, this adds the authorization token, that should
 * be on every request made to the server.
 *
 * @export
 * @class APIServiceInterceptor
 */
@Injectable()
export class MsalInterceptorService implements HttpInterceptor {

  constructor(private msalService: MSALService,
    private store: Store<Auth>) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!endpointNeedsAdalToken(request)) {
      return next.handle(request);
    }
    return this.store.select(authSelectors.getAuthenticationStrategy).pipe(
      filter(strategy => !!strategy),
      switchMap((authStrategy: AuthStrategy) => {
        const token$ = authStrategy === AuthStrategy.OKTA ?
          this.store.select(authSelectors.getInternalUserToken) :
          this.getToken(`${getAdalEndpoint(request)}${DEFAULT_SCOPE}`);

        return token$.pipe(
          mergeMap((token:string) => {
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            });
            return next.handle(request);
          })
        );
      }));
  }

  private getToken(resourceId: string): Observable<string> {
    return Observable.create((observer) => {
      this.msalService.acquireToken(resourceId, (_message, token) => {
        observer.next(token);
        observer.complete();
      });
    });
  }
}
